var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-12 pb-20"},[_c('SectionIntro',{attrs:{"title":_vm.$t('cookies.privacy_policy')}}),_vm._v(" "),_c('div',{staticClass:"grid grid-cols-12"},[_c('div',{staticClass:"tinymce-content mt-8 col-span-12 lg:col-span-8 lg:col-start-3",domProps:{"innerHTML":_vm._s(_vm.model.translations[0].text)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }